import {modal} from "../UI/modal";
import {notice} from "../UI/notice";
import {fieldValidator, formDataFBuilder} from "../Core/common";
import Agent from "../Core/agent";
import StarRating from "star-rating.js";

const state = {
    addButton: null,
    form: null,
    modal: null
};

const modalConfig = {
    'size': '',
    'title': `<div class="fs-lg-32 fs-md-28 fs-24 fw-black text-second">Оставьте отзыв </div>`,
    'message': '',
    'footer': '',
    'header': function () {
        return `<div class="modal-header">
                <button class="btn-close btn-inline href-main position-absolute d-flex bg-transparent" data-bs-dismiss="modal"><i class="icon close fs-24"></i></button>
            </div>`;
    },
    'closeBtm': `<button class="btn-close position-absolute top-0 end-0 rounded-circle p-5 d-flex border-0 mt-sm-20 mt-10 me-sm-20 me-10" type="button" data-bs-dismiss="modal" aria-label="Close"><i class="close fs-20 text-second"></i></button>`,
    showEvent: function () {
    },
    hiddenEvent: function () {
    },
    hideEvent: function () {
    },
};

const addComment = form => {
    let inputs = form.querySelectorAll(`input, textarea, select`);
    let isError = false;

    inputs.forEach(el => {
        if (el.hasAttribute('name')) {
            if (!fieldValidator(el)) {
                isError = true;
            }
        }
    });

    if (!isError) {
        let data = formDataFBuilder(form);
        state.addButton.disabled = true;
        state.addButton.classList.add('preloader');

        Agent.post('/api/comment/create', data)
            .then(e => e.json())
            .then(e => {
                notice(e.message);
                if (e.success && state.modal) {
                    state.modal.hide();
                }
            })
            .catch(e => console.log(e))
            .finally(() => {
                state.addButton.classList.remove('preloader');
                state.addButton.disabled = false;
            });
    }
};

export const initAddCommentForm = form => {
    state.addButton = form.querySelector('.js_add_comment');
    state.form = form;

    let required_field_flag;

    form.querySelectorAll(`input, textarea, select`).forEach(el => {
        if (el.hasAttribute('name')) {
            el.addEventListener('input', event => {
                    let input = fieldValidator.bind(null, event.currentTarget);
                    clearTimeout(required_field_flag);
                    required_field_flag = setTimeout(input, 1000);
                }
            );

            el.addEventListener('focus', () => {
                el.classList.remove('is-invalid');
                el.classList.remove('is-valid');
            });

            el.addEventListener('blur', event => {
                let input = fieldValidator.bind(null, event.currentTarget);
                clearTimeout(required_field_flag);
                required_field_flag = setTimeout(input, 10);
            });
        }
    });

    state.addButton.addEventListener('click', event => {
        event.preventDefault();
        addComment(form);
    });
};

const removeAddCommentEvent = () => {
    if (state.addButton) {
        state.addButton.removeEventListener('click', addComment.bind(null, state.addButton));
        state.addButton = null;
        state.form = null;
        state.modal = null;
    }
};

const showModel = (id, button) => {
    button.disabled = true;
    button.classList.add('preloader');

    Agent.post(`/api/comment/form/${id}`)
        .then(e => e.json())
        .then(e => {
            if (e.success) {
                modalConfig.message = e.data;
                modal(modalConfig,
                    function (modal, obj) {
                        state.modal = obj;
                        initAddCommentForm(modal.querySelector('form'));
                        modal.querySelectorAll('.star-rating').forEach(item => {
                            new StarRating(item, {
                                clearable: true,
                                tooltip: false,
                                maxStars: 5,
                            });
                        });

                    },
                    removeAddCommentEvent);
            } else {
                notice(e.message);
            }
        }).catch(e => console.log(e))
        .finally(() => {
            button.classList.remove('preloader');
            button.disabled = false;
        });
};

class Comment {
    constructor(events) {
        this.events = events;

        document.querySelectorAll('.js_open_modal_add_comment').forEach(item => {
            let id = item.dataset.id;
            item.addEventListener('click', () => {
                showModel(id, item);
            });
        });
    }
}

export const init = events => new Comment(events);

const addComments = form => {
    form.addEventListener('submit', event => {
        event.preventDefault();
        let data = formDataFBuilder(form);
        if (data.get('mail')) {
            return false;
        }

        let button = form.querySelector('.js_add_comment');

        button.classList.add('preloader');
        button.disabled = true;

        Agent.post('/api/comment/create', data)
            .then(e => e.json())
            .then(e => {
                notice(e.message);
                if (e.success) {
                    form.reset();
                }
            })
            .catch(e => console.log(e))
            .finally(() => {
                button.classList.remove('preloader');
                button.disabled = false;
            });
    });
}
export const initInline = element => addComments(element);

